<!-- 专家-详情 -->
<template>
  <div id="detail_accountManage" class="fromPage">
    <!-- 页面标题 -->
    <div class="title_page">专家详情</div>
    <!-- 基础信息 -->
    <div class="form_detail">
      <div v-for="(item,i) in keyItems" :key="i">
        <div>{{item.title}}</div>
        <div v-if="item.type=='status'" class="nowrap" :class="item.class_status?item.class_status[expertItem[item.key]]:''">
          {{item.text_status[expertItem[item.key]]?item.text_status[expertItem[item.key]]:'--'}}</div>
        <div v-else-if="item.type=='money'" class="nowrap">{{ `￥${common.formatNumber(expertItem[item.key])}`}}</div>
        <div v-else-if="item.type=='time'" class="nowrap">{{ expertItem[item.key]?moment(expertItem[item.key]).format('YYYY-MM-DD'):'--'}}</div>
        <div v-else-if="item.type=='file'" class="nowrap">
          <div v-if="expertItem[item.key]?.length>0">
            <div v-for="(f,i) in expertItem[item.key]" :key="i" class="file nowrap" @click="handleFileViewing(f)"> {{f?.name}}</div>
          </div>
          <div v-else style="color:#909399">暂无附件</div>
        </div>
        <div v-else>{{expertItem[item.key]?expertItem[item.key]:'--'}}</div>
      </div>
      <!-- 评审历史记录 -->
      <div class="smallTitle">评审历史记录</div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :cell-style="cellStyle" :header-cell-style="headerCellStyle" ref="table">
          <el-table-column v-for="(item,i) in tableKeys_current" :key="i" :prop="item.key" :label="item.title" :sortable="item.sortable?'custom':false"
            show-overflow-tooltip :min-width="item.width?item.width:''" :align="item.align??'center'">
            <template slot-scope="props">
              <div v-if="item.type=='status'" :class="item.class_status?(item.class_status[props.row[item.key]]):''">
                {{item.text_status[props.row[item.key]]?item.text_status[props.row[item.key]]:'--'}}</div>
              <div v-else-if="item.type=='money'" class="nowrap">{{ `￥${common.formatNumber(props.row[item.key])}`}}</div>
              <div v-else-if="item.type=='time'" class="nowrap">{{ props.row[item.key]?moment(props.row[item.key]).format('YYYY-MM-DD'):'--'}}
              </div>
              <div v-else class="nowrap">{{props.row[item.key]?props.row[item.key]:'--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="200" align="center">
            <template>
              <el-button type="text">查看评审报告</el-button>
            </template>
          </el-table-column>
          <div slot="empty">
            <img src="../../../assets/img/emptyData.png" alt="">
          </div>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <div v-show="InnerWH.width>450">共{{total}}条数据</div>
        <el-pagination hide-on-single-page background @current-change="handleCurrentChange" :current-page.sync="queryParam.page" :page-size="10"
          :pager-count="5" :layout="InnerWH.width>450?'prev, pager, next, jumper':'prev, pager, next'" :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 表单按钮 -->
    <div class="absoluteGrop">
      <el-button type="primary" plain @click="$router.push({path:'/accountPages/edit_expert',query:{id:expertItem.id}})">编辑</el-button>
      <el-button type="danger" plain @click="delRow">删除</el-button>
      <el-button plain @click="$router.go(-1)">返 回</el-button>
    </div>
    <!-- 预览组件 -->
    <PreviewFile ref="previewFile"></PreviewFile>
  </div>
</template>
<script>
import moment from 'moment';
import PreviewFile from "../../../components/file-preview.vue"
export default {
  name: "detail_accountManage",
  components: { PreviewFile },
  data() {
    return {
      moment: moment,
      expertItem: {},
      // 信息字段
      keyItems: [
        { title: "专家姓名", key: "expertName" },
        { title: "专家性别", key: "gender", type: 'status', text_status: ['', '男', '女'] },
        { title: "专家年龄", key: "age" },
        { title: "专家身份证", key: "identityCard", type: 'file' },
        { title: "专家工作照", key: "workPhoto", type: 'file' },
        { title: "电子签名", key: "signature", type: 'file' },
        { title: "目前所涉及的行业", key: "category" },
        { title: "专家职称级别", key: "rank", type: 'status', text_status: ['', '初级职称', '中级职称', '高级职称'] },
        { title: "专家所属单位", key: "affiliatedUnit" },
        { title: "专家擅长模块", key: "adeptInfo" },
        { title: "用户名/邮箱", key: "registerMail" },
        { title: "联系电话", key: "contactsPhone" },
        { title: "新增时间", key: "createTime", type: "time" },
        { title: "参与评审次数", key: "number" },
      ],
      // 列表字段合集
      tableKeys_current: [
        { title: "评审状态", key: "status", type: 'status', text_status: ['评审中', '已完成'], width: 150 },
        { title: "用户名称", key: "projectName", width: 100 },
        { title: "评审模块", key: "status", width: 150 },
        { title: "专家综合评分", key: "number", width: 150 },
      ],
      // 列表查询传参
      queryParam: {
        id:this.$route.query.id,
        page: 1,
        limit: 10,
      },
      tableData: [],
      total: 0,
    };
  },
  created() {
    this.getInfo();
    this.getTableData();
  },
  computed: {
    InnerWH: function () {
      return this.$store.getters.getInnerWH;
    },
  },
  methods: {
    // 获取项目信息
    getInfo() {
      this.$axios
        .post(`${process.env.BASE_URL}api/user/userInfo`, { id: this.$route.query.id }).then((res) => {
          if (res.data.code == 200) {
            this.expertItem = res.data.data;
            let fileKes = ['identityCard', 'workPhoto', 'signature'];
            fileKes.forEach((key, i) => {
              if (res.data.data[key] && res.data.data[key] != '') {
                this.$set(this.expertItem, key, JSON.parse(res.data.data[key]))
              }
            });
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取评审记录
    getTableData() {
      this.$axios
        .post(`${process.env.BASE_URL}api/review/historyList`, this.queryParam).then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.page.list;
            this.total = res.data.page.totalCount;
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 列表-分页-变更当前页
    handleCurrentChange(val) {
      this.queryParam.page = val;
      this.getTableData();
    },
    // 删除
    delRow() {
      this.$msgbox({
        title: '删除',
        message: `是否删除该专家？`,
        showCancelButton: true,
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            let that = this;
            this.$axios
              .post(`${process.env.BASE_URL}api/user/deleteUser`, { id: this.expertItem.id }).then(res => {
                if (res.data.code == 200) {
                  that.$message({
                    message: '删除成功',
                    type: "error"
                  });
                  this.$router.push('/accountPages/expertManage')
                } else {
                  that.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              }).catch(() => {
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              });
          } else {
            //确认弹窗还原&关闭
            instance.confirmButtonText = '确定';
            instance.confirmButtonLoading = false;
            done();
          }
        }
      }).then(action => {
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消操作",
          offset: 100
        });
      })
    },
    // 预览
    handleFileViewing(file) {
      this.$refs.previewFile.openDrawer([file]);
    },
    // 列表-表头样式
    headerCellStyle(header) {
      if (header.column.order == "ascending" || header.column.order == "descending") {
        return { color: "#3D7BDC", fontSize: "14px", fontWeight: 400, background: '#f9fafb' };
      } else {
        return { color: "#617180", fontSize: "14px", fontWeight: 400, background: '#f9fafb' };
      }
    },
    // 列表-单元格样式
    cellStyle() {
      return {
        fontSize: "14px",
        color: "#111928",
        fontWeight: 500,
        padding: "8px 0px",
        background: '#f9fafb'
      };
    },
  },
};
</script>
<style lang="less" scoped>
.form_detail {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
  color: #111928;
  height: calc(100vh - 200px);
  overflow: auto;
  > div {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #e5e7eb;
    > div {
      padding: 8px 15px;
    }
    > div:first-child {
      color: #6b7280;
      width: 18vh;
      position: relative;
      flex-shrink: 0;

      &::after {
        content: "";
        position: absolute;
        right: 0px;
        width: 2px;
        height: 60%;
        top: 20%;
        font-size: 20px;
        background: #e5e7eb;
      }
    }
    .file {
      text-decoration-line: underline;
      cursor: pointer;
    }
  }
}
.smallTitle {
  padding: 8px 15px;
  color: #6b7280;
  width: 200px;
}
</style> 